import ES from './es';
import EN from './en';

const profile = {
    ES,
    EN
};

export default profile;
